import { STRAPI_DEVELOPMENT, STRAPI_PRODUCTION } from "../../constants/Api";

export const changePassword = (data, token) => {
  return new Promise((resolve, reject) => {
    fetch(
      process.env.NODE_ENV === "production"
        ? `${STRAPI_PRODUCTION}/custom/change-password`
        : `${STRAPI_DEVELOPMENT}/custom/change-password`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    )
      .then(async (data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
